import { ReactElement } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { Spinner } from 'react-bootstrap'

import { I18n, Translate } from 'common'
import { Sanitized } from '../../../../../src/features/search/Results/utils/Sanitized'
import { breakpoints } from '../../../../../src/theme/breakpoints'
import { Divider } from '@mui/material'
import { useSearchStore } from 'src/store/search/SearchStore'
import { ProductInformationProps } from './productDetails/interfaces'

const ProductSpecifications = observer(
  ({ partDetails, selectedProduct }: ProductInformationProps): ReactElement => {
    const { partDetailsLoading } = useSearchStore()

    return (
      <ProductSpecificationContainer>
        <DetailsContainerMobile>
          <Title>
            <I18n name="partDetails" />
          </Title>
          <ProductDescription>
            <ProductDetailsTable>
              <DetialRow>
                <ProdcutDetail>
                  <b>
                    <I18n name="Part#" />
                  </b>
                  <span>{selectedProduct?.partNumber}</span>
                </ProdcutDetail>
                <ProdcutDetail>
                  <b>
                    <I18n name="lineCode" />
                  </b>
                  <span>{selectedProduct?.lineCode}</span>
                </ProdcutDetail>
              </DetialRow>
              <DetialRow>
                <ProdcutDetail>
                  <b>
                    <I18n name="Part#" />
                  </b>
                  <span>{selectedProduct?.partNumber}</span>
                </ProdcutDetail>
                <ProdcutDetail>
                  <b>
                    <I18n name="lineCode" />
                  </b>
                  <span>{selectedProduct?.lineCode}</span>
                </ProdcutDetail>
              </DetialRow>
              <DetialRow>
                <ProdcutDetail style={{ width: '100%' }}>
                  <b>
                    <I18n name="warranty" /> #
                  </b>
                  <span>{selectedProduct?.extendedDescription}</span>
                </ProdcutDetail>
              </DetialRow>
            </ProductDetailsTable>
          </ProductDescription>
        </DetailsContainerMobile>
        <Divider />
        <DetailsContainer>
          <Title>
            <I18n name="details" />
          </Title>
          {partDetailsLoading && <Spinner animation="border" />}
          {partDetails.applicationSummary === '' &&
          partDetails.marketingDescription === null ? (
            <Paragrah>{Translate('noData')}</Paragrah>
          ) : null}
          <Paragrah>{partDetails.applicationSummary}</Paragrah>
          <Sanitized html={partDetails.marketingDescription || ''} />
        </DetailsContainer>
      </ProductSpecificationContainer>
    )
  }
)

export default ProductSpecifications

const DetailsContainer = styled.div`
  color: #050505;
  margin-left: 0;
  margin-top: 124px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    margin-top: 20px;
  }
`
const ProductDescription = styled.div``

const ProductDetailsTable = styled.div`
  display: flex;
  flex-direction: column;
`

const DetialRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px;
`

const ProdcutDetail = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`
const DetailsContainerMobile = styled.div`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    margin-top: 20px;
    color: #050505;
    margin-left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`
const ProductSpecificationContainer = styled.div`
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    margin: 15px;
  }
`

const Title = styled.h3`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  padding: 0px;
  margin-bottom: 16px;
`

const Paragrah = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: justify;
  padding: 0px;
  margin-top: 16px;
`
